/* The backend supports 'POPULAR' as a pseudo-continent that returns the most
 * popular locations.  Note that the definition of a continent here is rather
 * loose. 'AMERICA' includes both North and South America and 'AUSTRALIA' also
 * includes locations from the Oceania region.
 */
export enum Continent {
  POPULAR = 'POPULAR',
  AMERICA = 'AMERICA',
  ASIA = 'ASIA',
  AFRICA = 'AFRICA',
  AUSTRALIA = 'AUSTRALIA',
  EUROPE = 'EUROPE',
}

export enum EventListFilters {
  PAST = 'past',
  UPCOMING = 'upcoming',
}

export enum NewsCategory {
  INVESTOR = 'investor',
  MEDIA = 'media',
  SWISS = 'swiss',
  TEST = 'test',
}

export enum EventsCategory {
  INVESTOR = 'investor',
  MEDIA = 'media',
}

/*
 * The overall structure is <trading platform>_<stock symbol>.
 * SWX = Swiss Stock Exchange
 * OTCMKTS = OTC Markets
 * RHHBY = Roche Holding AG
 * RO = Roche Bearer share
 * ROG = Roche Non-Voting Equity Security
 */
export enum StockInformationCategory {
  OTCMKTS_RHHBY = 'OTCMKTS_RHHBY',
  SWX_RO = 'SWX_RO',
  SWX_ROG = 'SWX_ROG',
}

export interface LocationsSearchParams {
  continent: Continent;
  pageSize: number;
}

export interface NewsYearsSearchParams {
  category: NewsCategory;
}

export interface NewsSearchParams extends NewsYearsSearchParams {
  page?: number | string;
  year?: number | string;
  pageSize?: number | string;
}

export interface GetCountryLocationSearchParams {
  country: string;
}

export interface AdhocSearchParams {
  year?: number | string;
  page?: number | string;
}

export interface EventsSearchParams {
  category: EventsCategory;
  page?: number | string;
  year?: number | string;
}

export interface EventYearSearchParams {
  category: EventsCategory;
}

export interface PatientSearchParams {
  page?: number | string;
  country?: string;
}

export interface StockInformationSearchParams {
  category: StockInformationCategory;
}

export interface PubMedSearchParams {
  page?: number | string;
  size?: number | string;
}
